import React, { useMemo, useState, useEffect } from 'react';
import { useTable, usePagination, useGlobalFilter, useSortBy } from 'react-table';
import { Helmet } from 'react-helmet-async';
import { useTheme } from '@mui/material/styles';
import { Grid, Container, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,Button, Select, MenuItem, CircularProgress, FormControl, Dialog, DialogTitle, DialogContent, DialogActions, TextField, InputLabel, Alert } from '@mui/material';
import { Box } from '@mui/system';

const fetchData = async (url) => {
  const response = await fetch(url);
  return response.json();
};

export default function UserPage() {
  const theme = useTheme();
  const tipo = localStorage.getItem('Tipo');
  const transportista = localStorage.getItem('Transportista');
  const [mandante, setMandante] = useState(localStorage.getItem('Mandante')); 
  const [plantas, setPlantas] = useState([]);
  const [selectedPlanta, setSelectedPlanta] = useState('');
  const [selectedMes, setSelectedMes] = useState('');
  const [selectedAño, setSelectedAño] = useState('');
  const [consultado, setConsultado] = useState(false);
  const [jsonInformes, setJsonInformes] = useState([]);
  const [isLoading, setIsLoading] = useState(false); 
  const [updateInfo, setUpdateInfo] = useState(true); 

  const currentYear = new Date().getFullYear();
  const years = [currentYear, currentYear - 1];
  const months = [...Array(12).keys()].map(i => ({
    value: i + 1,
    label: new Date(0, i + 1, 0).toLocaleString('es-ES', { month: 'long' })
  }));

  useEffect(() => {
    fetchData(`https://asetran.cl/api/enex/listado_planta.php?mandante=${mandante}&_=${new Date().getTime()}`)
      .then(data => setPlantas(data))
      .catch(error => console.error(error));

    setUpdateInfo(false)
  }, [updateInfo]);
  
  const data = useMemo(() => jsonInformes, [jsonInformes]);

  const columns = useMemo(() => [
    { Header: 'Usuario', accessor: 'Usuario' },
    { Header: 'Patente', accessor: 'Identificador' },
    { Header: 'Transportista', accessor: 'Transportista' },
    { Header: 'Fecha', accessor: 'Fecha' },
    { Header: 'Planta', accessor: 'Planta' },
    { Header: 'Resolución', accessor: 'Situacion' },
    { Header: 'PDF', Cell: ({ row }) => <Button variant="contained" color="warning" onClick={() => window.open(`/clients/enex/api/checklist${row.original.PDF}`)}>Descargar</Button> }
  ], []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    state: { pageIndex, pageSize, globalFilter },
    setGlobalFilter,
  } = useTable(
    { columns, data },
    useGlobalFilter, // Usar filtro global
    useSortBy,       // Usar ordenamiento
    usePagination
  );

  const handleConsultar = async () => {
    setConsultado(false);
    setIsLoading(true);
    let url
    if(transportista > 1){
      url = `https://asetran.cl/api/enex/transportista/listado_informes.php?&planta=${selectedPlanta}&mes=${selectedMes}&agno=${selectedAño}&mandante=${mandante}&_=${new Date().getTime()}`;
    } else {
      url = `https://asetran.cl/api/enex/listado_informes.php?&planta=${selectedPlanta}&mes=${selectedMes}&agno=${selectedAño}&mandante=${mandante}&_=${new Date().getTime()}`;  
    }
    const response = await fetch(url);
    const data = await response.json();
    
    setJsonInformes(data); // suponiendo que tienes un estado para este valor
    setConsultado(true);
    setIsLoading(false);
  };

  const handleMandante= async (id) => {
    setMandante(id)
    setUpdateInfo(true)
  };

  return (
    <>
      <Helmet>
        <title> ENEX Check - ASETRAN</title>
      </Helmet>

      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          INFORMES EMITIDOS 
        </Typography>

        {tipo === 'Administrador' && (
          <FormControl sx={{ minWidth: 200, marginLeft: '15px' }}>
            <InputLabel sx={{ marginTop: '-8px' }}>Mandante</InputLabel>
            <Select
              value={mandante}
              onChange={e => handleMandante(e.target.value)}
            >
                <MenuItem key={13} value={13}>ENEX</MenuItem>
                <MenuItem key={20} value={20}>MEJILLONES</MenuItem>
                <MenuItem key={22} value={22}>LA GREDA</MenuItem>
            </Select>
          </FormControl> 
        )}

        <FormControl sx={{ minWidth: 200, marginLeft: '15px' }}>
          <InputLabel sx={{ marginTop: '-8px' }}>Planta</InputLabel>
          <Select
            value={selectedPlanta}
            onChange={e => setSelectedPlanta(e.target.value)}
          >
            {plantas.map(item => 
              <MenuItem key={item.id} value={item.id}>{item.planta}</MenuItem>
            )}
          </Select>
        </FormControl>

        <FormControl sx={{ minWidth: 200, marginLeft: '15px' }}>
          <InputLabel sx={{ marginTop: '-8px' }}>Mes</InputLabel>
          <Select
            value={selectedMes}
            onChange={e => setSelectedMes(e.target.value)}
          >
            {months.map((month, index) => 
              <MenuItem key={index} value={month.value}>{month.label}</MenuItem>
            )}
          </Select>
        </FormControl>

        <FormControl sx={{ minWidth: 200, marginLeft: '15px' }}>
          <InputLabel sx={{ marginTop: '-8px' }}>Año</InputLabel>
          <Select
            value={selectedAño}
            onChange={e => setSelectedAño(e.target.value)}
          >
            {years.map(year => 
              <MenuItem key={year} value={year}>{year}</MenuItem>
            )}
          </Select>
        </FormControl>

        <Button variant="contained" color="primary" onClick={handleConsultar} sx={{ marginLeft: '15px' }}>
          {isLoading ? 'Cargando...' : 'Consultar'}
        </Button>
        {consultado && jsonInformes.length > 0 &&(      
          <Grid item xs={12} md={12} lg={12}>
            <Box sx={{ width: '100%', height: '100%', overflow: 'auto' }}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  marginBottom: '10px',
                }}
              >
                <TextField
                  value={globalFilter || ''}
                  onChange={e => setGlobalFilter(e.target.value)}
                  placeholder="Buscar..."
                  variant="outlined"
                  size="small"
                />
              </div>
              <TableContainer component={Paper} sx={{ width: '100%', overflow: 'auto' }}>
                <Table {...getTableProps()} sx={{ minWidth: 750 }}>
                  <TableHead>
                    {headerGroups.map(headerGroup => (
                      <TableRow {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map(column => (
                          <TableCell {...column.getHeaderProps(column.getSortByToggleProps())}>
                            {column.render('Header')}
                            <span>
                              {column.isSorted
                                ? column.isSortedDesc
                                  ? ' 🔽'
                                  : ' 🔼'
                                : ''}
                            </span>
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableHead>
                  <TableBody {...getTableBodyProps()}>
                    {page.map(row => {
                      prepareRow(row);
                      return (
                        <TableRow {...row.getRowProps()}>
                          {row.cells.map(cell => (
                            <TableCell {...cell.getCellProps()}>{cell.render('Cell')}</TableCell>
                          ))}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            

              <FormControl>
                <Typography component="div">
                  Página{' '}
                  <strong>
                    {pageIndex + 1} de {pageOptions.length}
                  </strong>{' '}
                </Typography>

              </FormControl>

              <Button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                {'<<'}
              </Button>
              <Button onClick={() => previousPage()} disabled={!canPreviousPage}>
                {'<'}
              </Button>
              <Button onClick={() => nextPage()} disabled={!canNextPage}>
                {'>'}
              </Button>
              <Button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                {'>>'}
              </Button>
            </Box>
            
          </Grid>
        )}
      </Container>
    </>
  );
}
